import * as api from "../../../api"; 
import { appTokenString } from "../../../constants/appInfo";

  
export const AddToCartClientApp = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.AddToCartClientApp(dataObject);
        
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}
export const PlaceOrderClientApp = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.PlaceOrderClientApp(dataObject);
        
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}

export const razorpayPaymentAPIClient = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.razorpayPaymentAPIClient(dataObject);
        
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}
